exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".scrollbar-inner .overflow-scroll[data-v-06b24e64] {\n  overflow: hidden;\n  overflow-y: scroll;\n}", "", {"version":3,"sources":["/var/www/html/brkt/src/app/layout/SidebarRight.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;EACD,mBAAA;CAAD","file":"SidebarRight.vue?vue&type=style&index=0&id=06b24e64&lang=scss&scoped=true","sourcesContent":["\n.scrollbar-inner .overflow-scroll{\n  overflow: hidden;\n overflow-y: scroll;\n}\n"],"sourceRoot":""}]);

// exports
